<h1 mat-dialog-title>
    <span [translate]="isCreation ? 'admin.entreprise.vehicules.puissances.creation' : 'admin.entreprise.vehicules.puissances.modification'"></span>
    <span [mat-dialog-close]="false"><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form #form="ngForm">
        <fieldset>
            <div class="row">
                <custom-input ngDefaultControl
                              id="libelle"
                              name="libelle"
                              [(ngModel)]="data.puissance.libelle"
                              customType="input"
                              libelle="admin.entreprise.vehicules.puissances.libelle"
                              maxlength="2000"
                              required="true"></custom-input>
                <custom-input ngDefaultControl
                              id="unite"
                              name="unite"
                              [selectOptions]="data.listeUnites"
                              optionValue="idUnite"
                              optionDisplay="libelle"
                              [(ngModel)]="data.puissance.idUnite"
                              customType="select"
                              libelle="admin.entreprise.vehicules.puissances.unite"></custom-input>
            </div>
        </fieldset>
    </form>
</div>
<div mat-dialog-actions *ngIf="!isLoading">
    <button mat-stroked-button color="warn" (click)="deletePuissance()" [disabled]="isLoading" *ngIf="data.puissance.idPuissance">
        <span *ngIf="!isLoading" [translate]="'global.actions.supprimer'"></span>
        <mat-spinner class="m-5" diameter="28" *ngIf="isLoading"></mat-spinner>
    </button>
    <button mat-flat-button color="primary" [disabled]="form.invalid || isLoading" (click)="savePuissance()">
        <span *ngIf="!isLoading" [translate]="'global.actions.enregistrer'"></span>
        <mat-spinner class="m-5" diameter="28" *ngIf="isLoading"></mat-spinner>
    </button>
</div>